export class Grupo {
  id: number;
  nome: string;
  descricao: string;
  setor: string;
  rodape: string;
  imagem_rodape: File;
  token: string;
}



// WEBPACK FOOTER //
// ./src/app/grupos/grupo.ts